import { flexRender, type Header } from "@tanstack/react-table";

function SortIcon({ direction }: { direction: false | "asc" | "desc" }) {
  if (!direction) {
    return (
      <span className="ml-1 inline-flex flex-col text-[9px] leading-none text-slate-400">
        <span>▲</span>
        <span className="-mt-0.5">▼</span>
      </span>
    );
  }
  return (
    <span className="ml-1 text-[10px] text-slate-600">
      {direction === "asc" ? "▲" : "▼"}
    </span>
  );
}

export function SortableHeader<T>({ header }: { header: Header<T, unknown> }) {
  const canSort = header.column.getCanSort();
  const sorted = header.column.getIsSorted();
  const align = header.column.columnDef.meta?.align;
  const justify =
    align === "end"
      ? "justify-end"
      : align === "center"
        ? "justify-center"
        : "justify-start";

  if (!canSort) {
    return flexRender(header.column.columnDef.header, header.getContext());
  }

  return (
    <button
      type="button"
      onClick={header.column.getToggleSortingHandler()}
      className={`inline-flex w-full cursor-pointer items-center gap-0.5 hover:text-slate-700 ${justify}`}
      aria-sort={
        sorted === "asc"
          ? "ascending"
          : sorted === "desc"
            ? "descending"
            : "none"
      }
    >
      {flexRender(header.column.columnDef.header, header.getContext())}
      <SortIcon direction={sorted} />
    </button>
  );
}
